import React, { useEffect } from 'react';
import { getQueryStringVariable } from '../data/utils';
import { PROVIDER_BETRADAR_WIDGET, WidgetContext } from '../data/widgets/WidgetContext';

function BetradarWidgetS5Component(props) {
    const widgetContext = React.useContext(WidgetContext);
    const isBrWidgetS5 = true;
    const sportId = props.sportId ||  getQueryStringVariable("sportId");
    const matchId = props.matchId || getQueryStringVariable("matchId");

    useEffect(() => {
            //if (isWidgetEnabled(state.match.sportRef)) {
            if (true) {
                widgetContext.setWidget({
                    widgetSportId: sportId,
                    widgetMatchId: matchId,
                    widgetProviderType:PROVIDER_BETRADAR_WIDGET,
                    widgetGeniusId:0,
                    widgetContainerId: '#betradarWidgetS5',
                    widgetStartCollapsed: false
                });
            } else {
                widgetContext.reset();
            }
    }, []);

    return (
        <div style={{'width':'500px'}} >
            <div id="betradarWidgetS5" className={`betradar-widget sr-widget sr-widget-level-0 sr-widgets-lmts sr-size-small sr480 ${isBrWidgetS5 ? 'brWidgetS5' : ''}`} data-sr-lang="it" data-sr-handle="16"></div>
        </div>
    );
}

export default BetradarWidgetS5Component;
